import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { Section, SectionTitle, InfoGrid, InfoItem } from './ProfileStyles';

/**
 * Endereço de correspondência do usuário (residencial ou comercial, o que
 * estiver marcado como correspondência). Pode ser null nas mesmas condições
 * de `contato` (ver ContactInfo).
 *
 * @param {Object|null} props.endereco - { cep, logradouro, numero, complemento, bairro, uf, cidade }
 */
export const ProfileAddress = ({ endereco }) => (
  <Section>
    <SectionTitle>
      <FaMapMarkerAlt /> Endereço de Correspondência
    </SectionTitle>

    {endereco ? (
      <InfoGrid>
        <InfoItem>
          <label>CEP</label>
          <span>{endereco.cep || 'Não informado'}</span>
        </InfoItem>

        <InfoItem>
          <label>Logradouro</label>
          <span>
            {endereco.logradouro || 'Não informado'}
            {endereco.numero ? `, ${endereco.numero}` : ''}
          </span>
        </InfoItem>

        {endereco.complemento && (
          <InfoItem>
            <label>Complemento</label>
            <span>{endereco.complemento}</span>
          </InfoItem>
        )}

        <InfoItem>
          <label>Bairro</label>
          <span>{endereco.bairro || 'Não informado'}</span>
        </InfoItem>

        <InfoItem>
          <label>Cidade/UF</label>
          <span>{endereco.cidade || 'Não informado'} - {endereco.uf || ''}</span>
        </InfoItem>
      </InfoGrid>
    ) : (
      <InfoGrid>
        <InfoItem>
          <span>Nenhum endereço de correspondência cadastrado</span>
        </InfoItem>
      </InfoGrid>
    )}
  </Section>
);
